export default {
  path: '/admin',
  name: 'Admin',
  component: () => import('../../views/Admin/AdminMaster.vue'),
  meta: {
    disableScrollToTop: true,
    isAdmin: true,
    hideChrome: true,
  },
  children: [
    {
      path: '',
      redirect: { name: 'AdminDash' },
    },
    {
      path: 'dash',
      name: 'AdminDash',
      component: () => import('../../views/Admin/AdminDash.vue'),
    },
    {
      path: 'extrato',
      name: 'AdminExtract',
      component: () => import('../../views/Admin/Extract/AdminExtract.vue'),
    },
    {
      path: 'escolher-empresa',
      name: 'AdminChooseCompany',
      component: () => import('../../views/Admin/AdminChooseCompany.vue'),
    },
    {
      path: 'category',
      name: 'Category',
      component: () => import('../../views/Admin/Categories/Category.vue'),
    },
    {
      path: 'remuneracoes-empresas',
      name: 'RewardTypeCompany',
      component: () => import('../../views/Admin/RewardTypeCompany/RewardTypeCompany.vue'),
    },
    {
      path: 'layoffs/upload',
      name: 'UploadLayoffs',
      component: () => import('../../views/Admin/Layoffs/UploadLayoffs.vue'),
    },
  ],
}
